import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import payleft from '../../assets/Payment/old-left-payment.png';
import paykotak from '../../assets/Payment/pay-kotak.png';
import payrazor from '../../assets/Payment/pay-razorpay.png';
import axiosMain from '../../axiosMain';
import { DataContext } from '../../context/DataProvider';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URLS } from '../../utils/baseUrls';
import tiger from "../../assets/icons/tiger.png";


const PaymentModal = ({ show, handleClose, objData }) => {

    const [selectedPayment, setSelectedPayment] = useState('Kotak');
    const [showPaymentInfo, setShowPaymentInfo] = useState(false);
    const [PaymentInfoData, setPaymentInfoData] = useState(null);
    const { setorderId, setsuccessCode } = useContext(DataContext);

    const navigate = useNavigate();
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.async = true;
        document.body.appendChild(script);
    }, []);

    // const openRazorpay = async () => {
    //     const options = {
    //         key: PaymentInfoData?.Key,
    //         amount: PaymentInfoData?.Amount,
    //         currency: "INR",
    //         name: "Name",
    //         description: "Test Transaction",
    //         image: "https://www.tendertiger.com/assets/images/logo.png",
    //         order_id: PaymentInfoData?.RazorOrderId,
    //         callback_url: "http://localhost:3000/Payment-Success",
    //         handler: function (response) {
    //             navigate("/Payment-Success", {
    //                 state: {
    //                     orderId: PaymentInfoData?.OrderId,
    //                     successCode: 1,
    //                 },
    //             });
    //         },
    //         prefill: {
    //             name: "SDP",
    //             email: "SDP@gmail.com",
    //             contact: "7365929937",
    //         },
    //         notes: {
    //             address: "Tender Tiger",
    //         },
    //         theme: {
    //             color: "#dbdbdb",
    //         },
    //     };

    //     const rzp = new window.Razorpay(options);
    //     await rzp.open();
    //     setorderId(PaymentInfoData?.OrderId);
    //     setsuccessCode(1);
    //     setShowPaymentInfo(false);
    // };

    const openRazorpay = async () => {

        const options = {

            key: PaymentInfoData?.Key,

            amount: PaymentInfoData?.Amount,

            currency: "INR",

            name: "Name",

            description: "Test Transaction",

            image: "https://www.tendertiger.com/assets/images/logo.png",

            order_id: PaymentInfoData?.RazorOrderId,



            handler: async function (response) {

                console.log("Razorpay Response:", response);
                setShowPaymentInfo(false);
                

                try {

                    const verifyResponse = await axiosMain.post(

                        BASE_URLS + "/UserPayment/HandleRazorPayResponse",

                        {

                            razorpay_payment_id: response.razorpay_payment_id,

                            razorpay_order_id: response.razorpay_order_id,

                            razorpay_signature: response.razorpay_signature,

                            orderId: PaymentInfoData?.OrderId,

                        }

                    );

                    console.log("verifyResponse", verifyResponse)



                    if (verifyResponse.data.SuccsessCode == 1) {

                        navigate("/Payment-Success", {

                            state: {

                                orderId: PaymentInfoData?.OrderId,

                                successCode: 1,

                                razorpayPaymentId: response.razorpay_payment_id,

                            },

                        });

                    } else {

                        alert("Payment verification failed.");

                    }

                } catch (err) {

                    console.error("Verification Error", err);

                    alert("Payment verification error occurred.");

                }

            },



            prefill: {

                name: "",

                email: "",

                contact: "",

            },

            notes: {

                address: "Tender GPT",

            },

            theme: {

                color: "#dbdbdb",

            },

        };



        const rzp = new window.Razorpay(options);

        rzp.open();

    };

    const handleChange = (e) => {
        setSelectedPayment(e.target.value);
    };
    const handleClosePaymentInfo = () => {
        setShowPaymentInfo(false);
        setSelectedPayment("Kotak")
    }

    const btn_PaySubmit = async () => {
        let localstoretoken = localStorage.getItem("logDetails");
        if (localstoretoken !== null) {
            var parseLocalStorage = JSON.parse(localstoretoken);
        }
        await axiosMain
            .post(BASE_URLS + "/UserPayment/RazorPayPayment",
                {
                    OrderId: objData?.OrderId,
                    EmailId: parseLocalStorage === undefined ? "" : parseLocalStorage.Email,
                    OrderNo: 0,
                    Amount: objData?.Amount,
                    NewOrReNew: "New",
                    //DomainUrl: "tendertiger.co.in",
                    PayCurrency: "INR",
                    PayMentMethodType: selectedPayment,
                    InputAmount: 0.0
                }
            )
            ?.then((res) => {
                if (res.data.Key !== "") {
                    setPaymentInfoData(res.data);
                    setShowPaymentInfo(true);
                    handleClose();
                }

            })
            ?.catch((err) => console.log(err));

    };

    return (
        <>
            <Modal className='payment-details-modal' show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header closeButton>
                    
                    <div className="header-content">
                        <div className="w-100">
                            <h4>Order & Payment Details</h4>
                            
                        </div>
                        <img className="width-35" src={tiger} alt="tiger-image"   />
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="payment d-flex">
                        

                        <div className="payment-right-bx order-payment-sec" style={{ display: 'block' }}>
                            <div className="signup-from-bx">
                                {/* Order Details Form */}
                                <form method="post" noValidate>
                                    <fieldset className="po-rel">
                                        

                                        <div className="Register-bx">
                                            <div className="form-group mb-2">
                                                <p className="order-number">
                                                    <b className="number-label order-label fixed-order-label">Order No</b>
                                                    <b className="order-colon"> :</b>
                                                    <span>{objData?.OrderId}</span>
                                                </p>

                                                <p className="order-data-time">
                                                    <b className="number-label order-label fixed-order-label">Date &amp; Time</b>
                                                    <b className="order-colon"> :</b>
                                                    <span>{objData?.OrderDateTime}</span>
                                                </p>

                                                <p className="order-Amount">
                                                    <b className="amount-label order-label fixed-order-label">Order Amount </b>
                                                    <b className="order-colon"> :</b>
                                                    <span className="enter-order-amount">
                                                        <span className="payment-currency-label">
                                                            <input type="text" className="amount-type" value="INR" disabled />
                                                        </span>
                                                        <span className="payment-amount">
                                                            <input type="number" value={objData?.PlanAmount} disabled />
                                                        </span>
                                                    </span>
                                                </p>

                                                <div>
                                                    <p className="gst-bx">
                                                        <b className="gst-blank-label order-label fixed-order-label">&nbsp;&nbsp;</b>
                                                        <b className="order-colon">&nbsp;</b>
                                                        <span className="gst">
                                                            <span className="gst-label">GST </span>
                                                            <span className="gst-amount"><span>{objData?.GSTAmount} </span> (18%)</span>
                                                        </span>
                                                    </p>

                                                    <p className="total-amount-bx">
                                                        <b className="total-amount-blank-label order-label fixed-order-label">&nbsp;&nbsp;</b>
                                                        <b className="order-colon">&nbsp;</b>
                                                        <span className="amount" style={{ fontWeight: 600 }}>
                                                            <span className="total-amount-label">INR </span>
                                                            <span className="total-amount">{objData?.Amount}</span>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                </form>

<hr></hr>
                                {/* Payment Selection Form */}
                                <form method="post" noValidate className="">
                                    <fieldset className="po-rel">
                                      

                                        <legend><h1 className="h4 m-0 p-1">Select Payment Type </h1></legend>

                                        <div className="payment-nots-view d-none">
                                            <p><b>Please read the instruction below :</b> You can pay us through Credit Card / ATM-CUM-DEBIT card / Internet Enabled Bank Account through our secure Payment gateway.</p>
                                            <p><b>Note :</b> To avoid Fraud cases, please fill correct credit card details, billing address, etc.</p>
                                        </div>

                                        <div className="Register-bx">
                                            <div className="form-group mb-2">
                                              
                                                <div className="select-payment-type">
                                                    <label className="radio-inline">
                                                        <input type="radio" value="Kotak" name="optradio" defaultChecked onChange={(e) => handleChange(e)} />
                                                        <img className="Pay-type-img" src={paykotak} alt="Kotak" />
                                                    </label>

                                                    <label className="radio-inline">
                                                        <input type="radio" value="RazorPay" name="optradio" onChange={(e) => handleChange(e)} />
                                                        <img className="Pay-type-img" src={payrazor} alt="RazorPay" />
                                                    </label>
                                                </div>

                                                <div>
                                                    {/* Extra dynamic dropdown if needed */}
                                                </div>

                                                <button type="button" className="btn Pay-Now " onClick={btn_PaySubmit}>Pay Now</button>
                                            </div>
                                        </div>
                                    </fieldset>
                                </form>

                                <p style={{ color: '#404040', fontSize: '12px' }}>
                                    Opportunities will be emailed to you after payment is successful &amp; you can access it on the website too.
                                </p>
                            </div>
                        </div>
                    </div>
                </Modal.Body>


            </Modal>
            {/* patment info modal */}
            <Modal className="amount-pay-info" show={showPaymentInfo} onHide={handleClosePaymentInfo} size="lg" centered>
                <Modal.Header closeButton className='pb-0'>
                  

                    
 <div className="header-content">
                        <div className="w-100">
                            <h4 className='m-0 p-0'>Payment Info</h4>
                            
                        </div>
                        <img className="width-35" src={tiger} alt="tiger-image"   />
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <table className="table key-info" bordered>
                        <tbody>
                            <tr>
                                <td className="text-left amount-pay-info-label">Company Name</td>
                                <td className="text-left amount-pay-info-colon">:</td>
                                <td className="text-left text-left amount-pay-info-view">{PaymentInfoData?.Name}</td>
                            </tr>
                            <tr>
                                <td className="text-left amount-pay-info-label">Order No</td>
                                <td className="text-left amount-pay-info-colon">:</td>
                                <td className="text-left amount-pay-info-view ">{PaymentInfoData?.OrderId}</td>
                            </tr>
                            <tr>
                                <td className="text-left amount-pay-info-label">Order Amount</td>
                                <td className="text-left amount-pay-info-colon">:</td>
                                <td className="text-left amount-pay-info-view">{(PaymentInfoData?.Amount) / 100}</td>
                            </tr>
                            <tr>
                                <td className="text-left amount-pay-info-label">Payment Type</td>
                                <td className="text-left amount-pay-info-colon">:</td>
                                <td className="text-left amount-pay-info-view">{selectedPayment}</td>
                            </tr>
                        </tbody>
                    </table>
<div className='aline-center mt-3'>
    
<Button className='pay-Cancel' variant="secondary" onClick={() => { handleClose(); handleClosePaymentInfo(); }}>
                        Cancel
                    </Button>
                    <Button className='pay-now'
                        variant="success"
                        onClick={() => {
                            openRazorpay();
                        }}
                    >
                        Pay Now
                    </Button>
</div>
                </Modal.Body>
              
            </Modal>
        </>
    );
};

export default PaymentModal;
